import type { SVGProps } from 'react';
const SvgBolt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.317 3a1.12 1.12 0 0 1 1.078 1.43l-2.09 7.32h3.328a1.362 1.362 0 0 1 .883 2.402L10.41 22.734a1.12 1.12 0 0 1-1.805-1.164l2.09-7.32H7.316a1.317 1.317 0 0 1-.855-2.316L16.59 3.27c.203-.176.46-.27.727-.27m-1.41 3.32-7.079 6.055h3.11c.292 0 .57.137.75.371s.234.54.152.82L11.09 19.7l7.156-6.074h-3.183a.95.95 0 0 1-.75-.371.92.92 0 0 1-.153-.82z"
    />
  </svg>
);
export default SvgBolt;
